import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const PlusIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12M6 12h12" />
  );

  return (
    <Icon
      svgPath={svgPath}
      className={className}
      title={title}
      fill="none"
      strokeWidth={1.5}
    />
  );
};

export default PlusIcon;
